export default __webpack_public_path__ + "static/media/1617 spice rack side.cb920571.png";